<footer style="z-index: 2">
  <div class="footer-container">
    <div class="footer-content">
      <div class="brand-section">
        <img src="assets/img/footer-logo.webp" alt="Serkan Logo" class="footer-logo" />
        <p>{{ 'f-description' | transloco }}</p>
        <p class="contact-info">
          <span><i class="fa-duotone fa-solid fa-house-chimney"></i> Oberaustrasse 46, 6800 Feldkirch </span>
          <span><i class="fa-solid fa-phone"></i> +43 (660) 176 23 99 </span>
          <span><i class="fa-solid fa-paper-plane"></i> info&#64;serkanyarar.dev</span>
        </p>
        <div class="social-icons">
          <a href="https://www.facebook.com/serkan.yarar96" target="_blank" rel="noopener noreferrer" title="Facebook"><i class="fa-brands fa-facebook"></i></a>
          <a href="https://instagram.com/serkan.yarar/" target="_blank" rel="noopener noreferrer" title="Instagram"><i class="fa-brands fa-instagram"></i></a>
          <a href="https://x.com/serkanyarar96" target="_blank" rel="noopener noreferrer" title="Twitter"><i class="fa-brands fa-x-twitter"></i> </a>
          <a href="https://linkedin.com/in/serkanyarar" target="_blank" rel="noopener noreferrer" title="Linked-in"><i class="fa-brands fa-linkedin"></i></a>
          <a href="https://github.com/serkanyararr" target="_blank" rel="noopener noreferrer" title="Github"><i class="fa-brands fa-github"></i></a>
          <a href="https://www.youtube.com/c/serkanyarar/" target="_blank" rel="noopener noreferrer" title="Youtube"><i class="fa-brands fa-youtube"></i></a>
        </div>
      </div>
      <div class="footer-section">
        <h4>{{ 'f-services-title' | transloco }}</h4>
        <ul>
          <li>
            <a href="#.">{{ 'f-services-it' | transloco }}</a>
          </li>
          <li>
            <a href="#.">{{ 'f-services-logo-design' | transloco }}</a>
          </li>
          <li>
            <a href="#.">{{ 'f-services-website' | transloco }}</a>
          </li>
          <li>
            <a href="#.">{{ 'f-services-android' | transloco }}</a>
          </li>
          <li>
            <a href="#.">{{ 'f-services-ui-ux' | transloco }}</a>
          </li>
          <li>
            <a href="#.">{{ 'f-services-database' | transloco }}</a>
          </li>
          <li>
            <a href="#.">{{ 'f-services-crm' | transloco }}</a>
          </li>
          <li>
            <a href="#.">{{ 'f-services-software' | transloco }}</a>
          </li>
        </ul>
      </div>
      <div class="footer-section">
        <h4>{{ 'f-quick-access' | transloco }}</h4>
        <ul>
          <li>
            <a href="https://serkanyarar.dev">{{ 'f-about-me' | transloco }}</a>
          </li>
          <li>
            <a href="https://book.serkanyarar.dev">{{ 'f-my-bookshelf' | transloco }}</a>
          </li>
          <li>
            <a href="https://certificate.serkanyarar.dev">{{ 'f-certificates' | transloco }}</a>
          </li>
          <li>
            <a href="https://dna.serkanyarar.dev">{{ 'f-dna' | transloco }}</a>
          </li>
          <li>
            <a href="https://gamer.serkanyarar.dev">{{ 'f-gamer-zone' | transloco }}</a>
          </li>
          <li>
            <a href="#">{{ 'f-shop' | transloco }}</a>
          </li>
          <li>
            <a href="#">{{ 'f-refund' | transloco }}</a>
          </li>
          <li>
            <a href="#">{{ 'f-privacy-policy' | transloco }}</a>
          </li>
          <li>
            <a href="#">{{ 'f-terms-conditions' | transloco }}</a>
          </li>
        </ul>
      </div>
      <div class="footer-section">
        <h4>{{ 'f-newsletter-title' | transloco }}</h4>
        <p>{{ 'f-newsletter-description' | transloco }}</p>
        <form>
          <input type="email" placeholder="{{ 'f-email-placeholder' | transloco }}" />
          <button type="submit">{{ 'f-newsletter-button' | transloco }}</button>
        </form>
        <p>{{ 'f-newsletter-privacy' | transloco }}</p>
      </div>
    </div>
    <div class="footer-bottom">
      <p>
        <span>{{ appVersion }}</span>
        <span class="dot">&#x2022;</span>
        <span>Angular v{{ angularVersion }}</span>
        <span class="dot">&#x2022;</span>
        {{ copyright }} <a href="https://serkanyarar.dev">Serkan YARAR</a>
        <span class="dot">&#x2022;</span>
        {{ 'f-all-rights-reserved' | transloco }}
      </p>
    </div>
  </div>
</footer>
